import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BasicService } from '../../providers/basic';
import { environment as config } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../auth/auth.service';
import { FormBuilder, Validators } from '@angular/forms';
import { empty, merge } from 'ramda/es';
import { assoc } from 'ramda';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ISession } from '../../models/session';

@Injectable()
export class UsersService extends BasicService {
  private USER_API = config.users.url;

  constructor(
    protected auth: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp,
  ) {
    super(auth, translate);
  }

  public getRegisteredUsers(id: string, notify: boolean = false) {
    return this.http
      .get(`${this.USER_API}/sessions/${id}/users/registered`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/email/users.service.ts